import React, { useEffect, useState } from 'react'
import { constructUrl } from '../../../services/common'
import { icon } from '../../../services/icon'
import Link from '../../fiche/link/Link'

const SearchResult = ({ data, value }) => {
    const [count, setCount] = useState(0)
    const [text, setText] = useState('résultat(s)')
    const [categorySelected, setCategorySelected] = useState(null)
    const [dataSelected, setDataSelected] = useState(data)

    useEffect(() => {
        const total = dataSelected ? Object.values(dataSelected).flat().length : 0
        setCount(total)
    }, [dataSelected])

    useEffect(() => {
        if (!categorySelected) {
            setDataSelected(data)
            setText('résultat(s)')
        } else {
            const dataFiltered = { [categorySelected]: data[categorySelected] }
            const textReplace = categorySelected.replace('-', ' ')
            setDataSelected(dataFiltered)
            setText(textReplace)
        }
    }, [categorySelected, data])

    const handleButtonClick = (key) => {
        setCategorySelected(categorySelected ? null : key)
    }

    return (
        <div className="baseocom-search-results">
            <h2>
                <strong>
                    {count} {text}
                </strong>{' '}
                pour <strong>: « {value} »</strong>
            </h2>

            <div className="baseocom-results-content">
                {Object.entries(dataSelected).map(([key, value]) => {
                    const category = key.replace('-', ' ')
                    const totalByCategory = value.length
                    const itemsDisplayed = categorySelected ? value : value.slice(0, 10)

                    return (
                        totalByCategory !== 0 && (
                            <div key={key} className="baseocom-result-by-category">
                                <h3>
                                    {category} ({totalByCategory})
                                </h3>
                                <div className="baseocom-flex baseocom-flex-col baseocom-gap-2">
                                    {itemsDisplayed.map((item, index) => (
                                        <Link
                                            key={index}
                                            isIcon={false}
                                            url={
                                                item?.url
                                                    ? item?.url
                                                    : constructUrl(item?.identifier, item?.audience)
                                            }
                                        >
                                            <span className="baseocom-mb-1 baseocom-mr-1">
                                                {icon('arrow-right')}
                                            </span>
                                            {item?.title}
                                        </Link>
                                    ))}
                                </div>
                                {!categorySelected ? (
                                    totalByCategory > itemsDisplayed.length && (
                                        <div className="baseo-button-view-more">
                                            <button
                                                type="button"
                                                onClick={() => handleButtonClick(key)}
                                            >
                                                Voir plus
                                            </button>
                                        </div>
                                    )
                                ) : (
                                    <div className="baseo-button-view-more">
                                        <button
                                            type="button"
                                            onClick={() => handleButtonClick(key)}
                                        >
                                            <span>Retour</span>
                                        </button>
                                    </div>
                                )}
                            </div>
                        )
                    )
                })}
            </div>
        </div>
    )
}

export default SearchResult
